import React from 'react';

import {TiDelete} from 'react-icons/ti';

import { Card, Col, Button } from "react-bootstrap";

const CardInfo = ({title, id, resume, expirationDate, benefit, setData, isAdmin, deleteFunc}) => {
    if(!isAdmin){ isAdmin = false}
    return ( 
            <Col className=" mt-4 float-left" lg={4} >
                <Card style={{ width: '100%' }}  className="shadow mb-4 box"> 
                    <Card.Header className="card-header py-3 m-0 font-weight-bold text-info">
                        <span>{title}</span>
                        {isAdmin ? <Button size={"sm"} variant="outline-danger" className="float-right" onClick={()=>{deleteFunc(id)}}><TiDelete /></Button> : null }
                    </Card.Header>                  
                    <Card.Body>
                        <Card.Text>{resume}</Card.Text>
                        {isAdmin ? 
                            <>
                                <Button className="float-right" variant="outline-warning" onClick={ () => setData(benefit)}>Editar</Button> 
                            </>
                            :
                        <Button className="float-right" variant="outline-info" onClick={ () => setData(title, resume, expirationDate)}>Ver más...</Button>
                        }
                    </Card.Body>
                    <Card.Footer>
                        <small className="text-muted">Válido hasta {expirationDate}</small>
                    </Card.Footer>
                </Card>
            </Col>
     );
}
 
export default CardInfo;